import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { typography, spacing, components } from '../utils/designTokens';

const CodeSnippet = ({ code, language = 'python', showCopy = true }) => {
  if (!code) throw new Error('CodeSnippet requires code prop');

  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (!code) return;

    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy code:', err);
    }
  };

  return (
    <div className="relative">
      <div className={`${components.card.bg} border border-accent-lavender/30 rounded-lg overflow-hidden`}>
        {/* Language badge and copy button */}
        <div className="flex items-center justify-between px-4 py-2 bg-background-tertiary border-b border-accent-lavender/20">
          <span className={`${typography.size.xs} text-text-muted uppercase tracking-wider`}>
            {language}
          </span>
          {showCopy && (
            <button
              onClick={handleCopy}
              className="flex items-center gap-1.5 px-2 py-1 rounded text-xs text-text-secondary hover:text-text-primary hover:bg-background-secondary transition-colors"
              aria-label="Copy code"
            >
              {copied ? (
                <>
                  <Check size={14} />
                  <span>Copied!</span>
                </>
              ) : (
                <>
                  <Copy size={14} />
                  <span>Copy</span>
                </>
              )}
            </button>
          )}
        </div>

        {/* Code content */}
        <pre className="overflow-x-auto p-4">
          <code className={`${typography.size.sm} text-text-primary font-mono leading-relaxed`}>
            {code}
          </code>
        </pre>
      </div>
    </div>
  );
};

export default CodeSnippet;
